export default "__VITE_ASSET__C4oOnEg2__"